import { Component } from '@angular/core';
import { soundpostAccountingEntryLineEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Accounting Entry Lines') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostaccountingentryline-form',
    templateUrl: './soundpostaccountingentryline.form.component.html'
})
export class soundpostAccountingEntryLineFormComponent extends BaseFormComponent {
    public record!: soundpostAccountingEntryLineEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'accountingEntryLineDimensions', sectionName: 'Accounting Entry Line Dimensions', isExpanded: false }
        ]);
    }
}

